export default "__VITE_ASSET__BYKxsELM__"